import { DataContainer, submitEvent } from '@otto-ec/tracking-bct';

export function trackEvent(data: DataContainer) {
    try {
        submitEvent(data);
        /*                                */
    } catch (e) {}
}
